import { getChildProfileCompletion } from "../../../utils/profileCompletion";
import { normalizeSupportProfile } from "../../../utils/supportProfile";
import { normalizeCareContext } from "../../../utils/careContext";
import { normalizeCareFocusSelection, splitCareFocusSelection } from "../../../constants/childProfileOptions";
import { deriveAgeGroupFromDateOfBirth, deriveAgeLabelFromDateOfBirth } from "../../../utils/profileAge";
import { EMPTY_PROFILE_DOCUMENTS } from "./profileSnapshot";

export const buildChildMedicalProfileUpdate = ({
  name = "",
  age = "",
  dateOfBirth = "",
  photoURL = "",
  selectedConditions = [],
  foodAllergies = [],
  dietaryRestrictions = [],
  sensoryIssues = [],
  behavioralTriggers = [],
  communicationNeeds = [],
  careContext = {},
  supportProfile = {},
  medicationRecords = [],
  profileDocuments = EMPTY_PROFILE_DOCUMENTS,
} = {}) => {
  const normalizedCareFocus = normalizeCareFocusSelection(selectedConditions);
  const { additionalSupports } = splitCareFocusSelection(normalizedCareFocus);
  const supplementEntries = medicationRecords.filter((entry) => ["supplement", "vitamin"].includes(entry?.category));
  const derivedAge = deriveAgeLabelFromDateOfBirth(dateOfBirth) || age;
  const derivedAgeGroup = deriveAgeGroupFromDateOfBirth(dateOfBirth) || careContext.ageGroup;
  const medicalProfile = {
    foodAllergies,
    dietaryRestrictions,
    sensoryIssues,
    behavioralTriggers,
    supplements: supplementEntries,
    communicationNeeds,
  };
  const completionScore = getChildProfileCompletion({
    name,
    age: derivedAge,
    photoURL,
    careContext: {
      careFocus: normalizedCareFocus,
      additionalSupports,
    },
    medicalProfile,
    supportProfile,
  });

  return {
    age: derivedAge,
    dateOfBirth,
    medicalProfile,
    careContext: normalizeCareContext({
      ...careContext,
      ageGroup: derivedAgeGroup,
      careFocus: normalizedCareFocus,
      additionalSupports,
    }),
    supportProfile: normalizeSupportProfile(supportProfile),
    profileDocuments,
    profileSetup: {
      stage: completionScore >= 100 ? "complete" : "in_progress",
      completed: completionScore >= 100,
      progress: completionScore,
      completedAt: completionScore >= 100 ? new Date().toISOString() : null,
    },
  };
};
